import streetService from 'services/streetService'
import { FETCH_STREETS, SET_STREETS } from './actions.type'

const initialState = {
  streets: []
}

export const state = { ...initialState }

export const actions = {
  async [FETCH_STREETS] (context, search) {
    const { data } = await streetService.fetchStreets(search)
    context.commit(SET_STREETS, data.results)
  }
}

export const mutations = {
  [SET_STREETS] (state, streets) {
    state.streets = streets
  }
}

const getters = {
  streets (state) {
    return state.streets
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/street.module.js